export default {
      id: "plantHover-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "icons.svg#plantHover",
      toString: function () {
        return this.url;
      }
    }